import {
  updatePersonalisationParams,
  setAdditionalQueryParams,
  updateAdditionalQueryParams,
  setNewSearch,
  clearNewSearch
} from "../../store/actionCreators";
import {
  updatePersonalisationParamsReducer,
  setAdditionalQueryParamsReducer,
  updateAdditionalQueryParamsReducer,
  setNewSearchReducer,
  clearNewSearchReducer
} from "../reducers";

export const registerQuerySlice = builder => {
  builder
    .addCase(updatePersonalisationParams, updatePersonalisationParamsReducer)
    .addCase(setAdditionalQueryParams, setAdditionalQueryParamsReducer)
    .addCase(updateAdditionalQueryParams, updateAdditionalQueryParamsReducer)
    .addCase(setNewSearch, setNewSearchReducer)
    .addCase(clearNewSearch, clearNewSearchReducer);
};
